module.exports = __webpack_public_path__ + "static/media/izlozba (22).8621736c.jpg";